module.exports = __webpack_public_path__ + "img/baptiste-photo.2ca4ac5a.png";